// Complete missing print-only concept labels; existing locale values remain authoritative.
export const EXISTING_PRINT_LABEL_COMPLETIONS = Object.freeze({
  "fr": {
    "professionalClothes": "Porte généralement des vêtements professionnels plutôt qu'un uniforme standard.",
    "wearsColourGarment": "Porte généralement une tenue {garment} de couleur {colour}.",
    "wearsGarment": "Porte généralement une tenue {garment}.",
    "preparationChecklist": "Liste de préparation",
    "understandingReminder": "Suivez les instructions de votre équipe hospitalière. Si quelque chose n'est pas clair, demandez à votre équipe de soins.",
    "whatYouMightHear": "Ce que vous pourriez entendre",
    "questionsToConsider": "Questions que vous pourriez poser",
    "peopleYouMayMeet": "Les professionnels que vous pourriez rencontrer",
    "officialHospitalInformation": "Informations utiles de l'hôpital",
    "localHospital": "Hôpital local"
  },
  "es": {
    "professionalClothes": "Normalmente lleva ropa profesional en lugar de un uniforme estándar.",
    "wearsColourGarment": "Normalmente lleva {garment} de color {colour}.",
    "wearsGarment": "Normalmente lleva {garment}.",
    "preparationChecklist": "Lista de preparación",
    "understandingReminder": "Siga las indicaciones del equipo de su hospital. Si algo no está claro, pregunte a su equipo asistencial.",
    "whatYouMightHear": "Lo que podría escuchar",
    "questionsToConsider": "Preguntas que podría querer hacer",
    "peopleYouMayMeet": "Personas que podría conocer",
    "officialHospitalInformation": "Información útil del hospital",
    "localHospital": "Hospital local"
  },
  "ar": {
    "professionalClothes": "عادةً ما يرتدي ملابس مهنية بدلاً من الزي الموحد المعتاد.",
    "wearsColourGarment": "عادةً ما يرتدي {garment} باللون {colour}.",
    "wearsGarment": "عادةً ما يرتدي {garment}.",
    "preparationChecklist": "قائمة الاستعداد",
    "understandingReminder": "اتبع تعليمات فريق المستشفى الذي يعالجك. وإذا لم تكن هناك نقطة واضحة، فاسأل فريق رعايتك.",
    "whatYouMightHear": "ما قد تسمعه",
    "questionsToConsider": "أسئلة قد ترغب في طرحها",
    "peopleYouMayMeet": "أشخاص قد تقابلهم",
    "officialHospitalInformation": "معلومات مفيدة من المستشفى",
    "localHospital": "المستشفى المحلي"
  },
  "pl": {
    "professionalClothes": "Zazwyczaj nosi ubranie zawodowe zamiast standardowego munduru.",
    "wearsColourGarment": "Zazwyczaj nosi {garment} w kolorze {colour}.",
    "wearsGarment": "Zazwyczaj nosi {garment}.",
    "preparationChecklist": "Lista przygotowań",
    "understandingReminder": "Postępuj zgodnie z zaleceniami personelu swojego szpitala. Jeśli coś jest niejasne, zapytaj zespół opieki.",
    "whatYouMightHear": "Co możesz usłyszeć",
    "questionsToConsider": "Pytania, które warto zadać",
    "peopleYouMayMeet": "Osoby, które możesz spotkać",
    "officialHospitalInformation": "Przydatne informacje ze szpitala",
    "localHospital": "Szpital lokalny"
  },
  "ur": {
    "professionalClothes": "عام طور پر معیاری یونیفارم کے بجائے پیشہ ورانہ لباس پہنتے ہیں۔",
    "wearsColourGarment": "عام طور پر {colour} رنگ کے {garment} پہنتے ہیں۔",
    "wearsGarment": "عام طور پر {garment} پہنتے ہیں۔",
    "preparationChecklist": "تیاری کی فہرست",
    "understandingReminder": "اپنی ہسپتال ٹیم کی ہدایات پر عمل کریں۔ کوئی بات واضح نہ ہو تو اپنی نگہداشت کی ٹیم سے پوچھیں۔",
    "whatYouMightHear": "آپ کیا سن سکتے ہیں",
    "questionsToConsider": "وہ سوالات جو آپ پوچھنا چاہیں",
    "peopleYouMayMeet": "وہ افراد جن سے آپ مل سکتے ہیں",
    "officialHospitalInformation": "ہسپتال سے مفید معلومات",
    "localHospital": "مقامی ہسپتال"
  }
});
